export const APP_TITLE = "DXC TWINSIGHT";
export const PROPERTIES = "PROPERTIES";
export const VIEWS = "VIEW LIBRARY";
export const VIEWS_MENU = "Views Menu";
export const TAXONOMY_EXPLORER = "Taxonomy Explorer";
export const LOGOUT = "LOGOUT";
export const SAVE_VIEW_BUTTON = "SAVE VIEW";
export const SAVE_IN_VIEW = "SAVE IN VIEW: ";
export const RESTORE_HERE = "RESTORE IN THIS VIEW";
export const IMPORT_VIEW = "IMPORT VIEW";
export const EXPORT_VIEW = "EXPORT VIEW";
export const RESTORE_NEW_TAB = "RESTORE IN NEW TAB";
export const DELETE_VIEW = "DELETE VIEW";
export const PLACEHOLDER_VIEW_NAME = "Enter view name.";
export const LOADING_VIEWS = "Loading Views...";
export const CONNECT_DATABASE = "Connect Database";
export const NEO4J_DATABASE_URL = "Neo4j Database URL";
export const NEO4J_URL = "Neo4j Url";
export const DATA_SERVICE = "Data Service";
export const USER = "User";
export const EMAIL = "Email";
export const PASSWORD = "Password";
export const NEW_PASSWORD = "Enter New Password";
export const DATABASE = "Database";
export const SUBMIT = "SUBMIT";
export const CONFIG_BUILDER_STRING = "Config the Builder";
export const START_CYPHER = "Start Sentence";
export const SELECT_CONTAINER_HIERARCHY = "Select Container Hierarchy";
export const OVERVIEW = "Overview";
export const CONTAINER_HIERARCHY = "Container Hierarchy";
export const SCHEMA_TREE = "Schema Tree";
export const HIERARCHY = "Hierarchy";
export const CYPHER = "Cyper";
export const NODE_LABELS = "Node Labels";
export const RELATIONSHIP_TYPES = "Relationship Types";
export const NODE_PROPERTIES = "Node Properties";
export const SHAPE_PROPERTIES = "Shape Properties";
export const RELATION_PROPERTIES = "Relation Properties";
export const NEW_TAB = "New Tab";
export const LOGIN = "LOGIN";
export const SELECT_DATABASE = "SELECT DATABASE";
export const SELECT_DATABASE_NEW = "SELECT DATABASE";
export const CHANGE_DATABASE = "CHANGE DATABASE";
export const CHANGE_DATABASE_lower = "Change Database";
export const CHANGE_PASSWORD = "CHANGE YOUR PASSWORD";
export const PASSWORD_CHANGED = "Password Changed, Login Again with the new Credentials.";
export const SUCCESS = "Success!";
export const ERROR = "Error! :(";
export const CONNECTION_SUCESSFUL = "Connection Successful";
export const CONNECTED_TO_DATASERVICE = "You are now connected to ${name} database";
export const CONNECTION_NOT_WORKING = "Connection not Working";
export const TRY_CONNECT_AGAIN = "Try to reconnect to the ${name} database";
export const TRY_AGAIN = "TRY AGAIN";
export const CANCEL_AND_LOGOUT = "CANCEL & LOGOUT";
export const CANCEL = "CANCEL";
export const CONNECT = "CONNECT";
export const CONTINUE = "CONTINUE";
export const SELECT_DATA_SERVICE_FIRST = "SELECT A DATA SERVICE FIRST";
export const RELATION_DOES_NOT_EXISTS = "Relation not founded or deleted from Database but it's still present on the view file."
export const NODE_DOES_NOT_EXISTS = "Node not founded or deleted from Database but it's still present on the view file."
export const CLOSE = "Close";
export const DELETE = "DELETE";
export const ARE_YOU_SURE = "Are you sure?";
export const SURE_DELETE_CONTAINER = "Are you sure to delete the container? all relationships related to that container are going be deleted as well."
export const SURE_DELETE_RELATION = "Are you sure to delete the Relationship? all relationships related to that container are going be deleted as well."
export const SURE_REMOVE_COMPANY = "Are you sure to remove access to the Company \"${}\"? all dataservices permissions are going to be deleted as well."
export const SURE_REMOVE_DATASERVICE = "Are you sure to remove access to the Dataservice \"${}\"?"
export const METRICS = "Metrics Info";
export const SIMULATION_INFO = "Simulation Info";
export const SCHEMA_OVERVIEW = "Schema Overview";
export const RESTORE_A_VIEW = "RESTORE A VIEW";
export const CREATE_NEW_VIEW = "CREATE NEW VIEW";
export const USER_VIEWS = "Views";
export const ACCOUNT = "Account";
export const SCHEMAS = "Schemas";
export const MODELS = "Models";
export const MODELS_OVERVIEW = "Models Overview";
export const HYPERFLOWS = "Connections with Other Models";

export const MOVE_NODES_TITLE = "Confirm Node Move";
export const MOVE_NODES_WARNING_TEXT = `
These nodes will be moved to a new parent.\n
In some cases, this action cannot be undone.\n
If any of the nodes are part of an existing view, that view may stop working.\n
Are you sure you want to continue?
`;

export const SURE_CHANGE_PROPERTIES = "You are about to change the property to all the selected nodes, are you sure to proceed?";

export const AFFECT_NODE_JSON = [
    {
        name: "ALL LABELS",
        value: "all_labels"
    },
    {
        name: "ALL NODES WITH SIMILAR PROPERTIE",
        value: "all_nodes_propiertie"
    },
    {
        name: "ONLY THIS NODE",
        value: "this_node"
    },
];

export const TAXONOMY_TREE_CONTEXT_MENU_OPTIONS = {
    show_hierarchy: "Show Hierarchy from here",
    show_hierarchy_no_father: "Show Hierarchy from here excluding father",
    only_children_no_chain: "Show only Children no chain",
    show_node: "Show Node",
    export_taxonomy: "Export Taxonomy to Json",
    export_hyperflows: "Export Hyperflows to Json",
    import_json: "Import Json File (Model and Flows / Hyperflows)",

    invalid_json_file: "Invalid JSON file: ",
    file_reading_error: "File reading error: "
}

export const FILE_IMPORT_NOTIFICATION = {
    importing_file: "Importing File",
    file_is_being_processed: "The file is being processed.",
    import_completed: "Import completed successfully.",
    import_error: "Import could not be completed."
}

export const CREATOR_NOTIFICATION = {
    creating_node: "Creating Node",
    delete_node: "Deleting Node",
    delete_relation: "Deleting Relationship",
    create_relation: "Creating Relationship",
    operation_is_being_processed: "The operation is being processed.",
    operation_complete: "Operation completed successfully.",
    operation_error: "Operation could not be completed."
}

export const CREATE_VIEW_FROM_CONTAINER = {
    title: "Created",
    content: "View created Sucessfully"
}